export function debounce<F extends (...args: Parameters<F>) => ReturnType<F>>(
  func: F,
  waitFor: number,
): (...args: Parameters<F>) => void {
  let timeout: NodeJS.Timeout;
  return (...args: Parameters<F>): void => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), waitFor);
  };
}

export function isEmpty(value: string) {
  return value.trim() === '';
}

export function isValidEmail(email: string) {
  const regex =
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

  return !!(email && regex.test(email));
}

export function isValidPassword(password: string) {
  // TODO: Change if needed
  return !!(password.trim().length >= 8);
}

export function buildParams(data: object) {
  const params = new URLSearchParams();

  Object.entries(data).forEach(([key, value]) => {
    if (!value) return;
    if (Array.isArray(value)) {
      value.forEach((el) => params.append(key, el.toString()));
    } else {
      params.append(key, value.toString());
    }
  });

  return params.toString();
}

export const toBool = (str: string | undefined | null) => {
  if (str === undefined || str === null) str = '';
  str = str.toString();
  switch (str.toLowerCase()) {
    case 'false':
    case 'no':
    case '0':
    case '': {
      return false;
    }

    default: {
      return true;
    }
  }
};

export function geoJsonToLatLng(loc: { coordinates: number[] }) {
  return {
    lat: loc.coordinates[1],
    lng: loc.coordinates[0],
  };
}

export function hasRoom(
  container: HTMLElement | null,
  element: HTMLElement | null,
  center?: boolean,
) {
  const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

  return (
    vw >
    (container?.getBoundingClientRect()?.left || 0) +
      (center ? (container?.offsetWidth || 0) / 2 : 0) +
      (element?.offsetWidth || 0) / (center ? 2 : 1) +
      24
  );
}

export function range(start: number, end: number) {
  const length = end - start + 1;
  return Array.from({ length }, (_, idx) => idx + start);
}

export function generateUEID() {
  let first = `${Math.random() * 46656 || 0}`;
  let second = `${Math.random() * 46656 || 0}`;
  first = `000${first.toString()}`.slice(-3);
  second = `000${second.toString()}`.slice(-3);

  return first + second;
}
